import React, { Fragment, useCallback, useEffect, useState } from 'react';
import styled from 'styled-components';
import { Body, Caption1 } from '../../../../components/Typography';
import Select from '../../../../components/Select';
import formatAddressName from '../../../../utils/formatAddressName';
import OrderFutureSchedule from './OrderFutureSchedule';
import UnavailableMessage from './UnavailableMessage';
import ConfirmButton from './ConfirmButton';
import UnavailableProducts from './UnavailableProducts';
import {
  renderConfirmButtonText,
  isConfirmButtonDisabled,
} from '../utils/helper';
import appConfig from '../../../../../app-config';
import SkeletonLoading from './SkeletonLoading';
import UnavailableMessageWithButton from './UnavailableMessageWithButton';
import { isScheduleRadioDisabledCalculated } from '../utils/helper';
import DeliveryOrderMessage from './DeliveryOrderMessage';
import GuestDeliveryAddressForm from './GuestDeliveryAddressForm';
import moment from 'moment';

const Wrapper = styled.div`
  display: grid;
  grid-gap: 24px;
`;

const SelectTitleWrapper = styled.div`
  display: grid;
  grid-gap: 10px;
`;

const GuestDeliveryForm = styled.div`
  display: grid;
  grid-gap: 10px;
`;

const AddNewButton = styled(Caption1)`
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  cursor: pointer;
  color: ${(props) => props.color || props.theme.clickableTextColor};

  &:hover {
    color: ${(props) => props.theme.clickableTextColorHover};
  }
`;

const Delivery = ({
  cartItems,
  deliveryAddressesList,
  updateInterDeliveryDetails,
  interDeliveryDetails,
  interSelectedDateTime,
  updateInterSelectedDateTime,
  interOrderType,
  unavailableProducts,
  availableTimes,
  getTimeIntervalsDate,
  resetInterSelectedDateTime,
  selectedDateTime,
  isRequesting,
  confirmDeliveryDetails,
  setDeliveryAddressesFormIsVisible,
  isTimeNoLongerValid,
  resetIsTimeNoLongerValid,
  isAuthenticated,
  handleConfirmDeliveryButton,
  specialHours,
  orderPacingData,
  orderSettingModalIsVisible,
  refine,
  cartErrorMessage,
  deliveryToAddress,
  deepLinkParameters,
  guestDeliveryFormInitialAddress,
  setGuestDeliveryAddressFormInitialValues,
  appConfig,
  cartReducer,
  validateCartForLocation,
  checkUnavailableProductForPickUp,
  getMenu,
  emptyCart,
  selectedLocation,
  updateSelectedLocation,
  updateOrderSettingModalIsVisible,
  storeId,
  showConfirmButton,
  setShowConfirmButton,
  validateGlobalCart,
}) => {
  const deliveryBusiness = selectedLocation
    ? selectedLocation.deliveryBusiness
    : null;

  const maxFutureOrderDate =
    selectedLocation &&
    selectedLocation.settings &&
    selectedLocation.settings.max_future_order_date;

  const orderEndTime =
    availableTimes &&
    availableTimes.length &&
    (availableTimes.length > 1
      ? availableTimes[1].order_end_time
      : availableTimes[0].order_end_time);

  const isAsapRadioDisabled = !(
    selectedLocation &&
    specialHours &&
    deliveryBusiness &&
    deliveryBusiness.accepting_orders &&
    !selectedLocation.settings.online
  );

  const isScheduleRadioDisabled = !(
    availableTimes &&
    maxFutureOrderDate &&
    orderEndTime &&
    specialHours &&
    !isScheduleRadioDisabledCalculated(
      availableTimes,
      maxFutureOrderDate,
      orderEndTime,
      specialHours,
      selectedLocation.settings.online
    )
  );
  const [deliveryLocation, setDeliveryLocation] = useState(null);

  useEffect(() => {
    if (!orderSettingModalIsVisible) {
      setDeliveryLocation(null);
    }
  }, [orderSettingModalIsVisible]);

  const emptySearchBox = () => {
    if (appConfig.isGlobalSearchEnabled) {
      refine('');
    }
  };
  useEffect(() => {
    if (deliveryToAddress) {
      const address = deliveryAddressesList.filter(
        (addr) => addr.line1 === deliveryToAddress.line1
      );
      if (address.length > 0) {
        setDeliveryLocation(address[0]);
        updateInterDeliveryDetails(address[0]);
      }
    }
  }, [deliveryToAddress, deliveryAddressesList]);

  useEffect(() => {
    if (deepLinkParameters?.id) {
      const address = deliveryAddressesList.filter(
        (addr) => addr.id === parseInt(deepLinkParameters.id)
      );
      if (address.length > 0) {
        setDeliveryLocation(address[0]);
      }
    }
  }, [deepLinkParameters, deliveryAddressesList]);

  const checkProductAvailibility = useCallback(() => {
    if (
      ((selectedLocation &&
        interSelectedDateTime.radioValue.value === 'asap') ||
        (interSelectedDateTime.radioValue.value === 'schedule' &&
          interSelectedDateTime.dateTime.time.value)) &&
      selectedLocation?.deliveryBusiness
    ) {
      if (deliveryBusiness?.id !== selectedLocation?.deliveryBusiness?.id)
        checkUnavailableProductForPickUp(
          selectedLocation.deliveryBusiness,
          true,
          selectedLocation.id
        );
    }
  }, [interSelectedDateTime, selectedLocation]);
  useEffect(() => {
    checkProductAvailibility();
  }, [checkProductAvailibility]);

  // useEffect(() => {
  //   if (
  //     (interSelectedDateTime.radioValue.value === 'asap' ||
  //       interSelectedDateTime.radioValue.value === 'schedule') &&
  //     selectedLocation &&
  //     selectedLocation.deliveryBusiness
  //   ) {
  // checkUnavailableProductForPickUp(
  //   selectedLocation.deliveryBusiness,
  //   true,
  //   selectedLocation.id
  // );
  //   }
  // }, [interSelectedDateTime.radioValue, selectedLocation]);

  useEffect(() => {
    if (storeId && !selectedLocation && orderSettingModalIsVisible) {
      updateSelectedLocation(interDeliveryDetails);
    }
  }, [storeId, orderSettingModalIsVisible]);

  const isValidChoice =
    selectedLocation && selectedLocation.settings && interSelectedDateTime
      ? (interSelectedDateTime.radioValue.value === 'asap' &&
          selectedLocation.settings.is_asap_order_enabled) ||
        (interSelectedDateTime.radioValue.value === 'schedule' &&
          selectedLocation.settings.is_future_order_enabled)
      : false;

  const updateConfirmButtonDisplay = useCallback(() => {
    if (
      !deliveryBusiness?.is_order_ahead_enabled ||
      !deliveryBusiness?.accepting_orders
    ) {
      setShowConfirmButton(false);
    } else {
      setShowConfirmButton(true);
    }
  }, [
    isRequesting,
    selectedLocation,
    availableTimes,
    deliveryBusiness,
    isScheduleRadioDisabled,
    isAsapRadioDisabled,
  ]);
  useEffect(() => {
    updateConfirmButtonDisplay();
  }, [updateConfirmButtonDisplay]);
  const getMessageWithButtonStatus = (deliveryBusiness) => {
    let isDisplayed = false;
    let message = '';
    if (deliveryBusiness) {
      if (!deliveryBusiness.open) {
        isDisplayed = true;
        message = 'Store is closed';
      } else {
        if (!deliveryBusiness.is_order_ahead_enabled) {
          isDisplayed = true;
          message =
            'Selected location is unable to accept orders at the moment';
        }
        // 'Your nearest location is unable to accept orders at the moment';
      }
    }
    return [isDisplayed, message];
  };
  const displayFullfillMessage = (deliveryBusiness, cartReducer) => {
    let isDisplayed = false;
    if (deliveryBusiness) {
      if (
        deliveryBusiness?.is_order_ahead_enabled &&
        deliveryBusiness?.accepting_orders &&
        cartReducer?.errors &&
        Object.keys(cartReducer?.errors ?? {}).length === 0 &&
        deliveryBusiness?.settings?.online
      ) {
        isDisplayed = true;
      }
    }
    return isDisplayed;
  };
  return (
    <Wrapper>
      {isAuthenticated ? (
        <>
          <SelectTitleWrapper>
            <Body style={{ fontWeight: 'bold' }}>Delivery to:</Body>
            <div style={{ marginRight: 'auto' }}>
              <AddNewButton
                onClick={() => {
                  setDeliveryAddressesFormIsVisible(true);
                }}
              >
                + Add New Address
              </AddNewButton>
            </div>
          </SelectTitleWrapper>
          <div>
            <Select
              value={
                selectedLocation?.deliveryBusiness ? selectedLocation : null
              }
              options={deliveryAddressesList}
              getOptionLabel={(deliveryAddress) =>
                formatAddressName(deliveryAddress)
              }
              getOptionValue={(deliveryAddress) => deliveryAddress}
              onChange={(deliveryAddress) => {
                updateInterDeliveryDetails(deliveryAddress);
                updateSelectedLocation(deliveryAddress);
                setDeliveryLocation(deliveryAddress);
              }}
              isDisabled={isRequesting}
            />
          </div>
        </>
      ) : appConfig && appConfig.guest_checkout_enabled ? (
        <GuestDeliveryForm>
          <Body style={{ fontWeight: 'bold' }}>Delivery to:</Body>
          <GuestDeliveryAddressForm
            guestDeliveryFormInitialAddress={guestDeliveryFormInitialAddress}
            updateInterDeliveryDetails={updateSelectedLocation}
            setGuestDeliveryAddressFormInitialValues={
              setGuestDeliveryAddressFormInitialValues
            }
          />
        </GuestDeliveryForm>
      ) : (
        <SelectTitleWrapper>
          <Body style={{ fontWeight: 'bold' }}>Delivery to:</Body>
          <div style={{ marginRight: 'auto' }}>
            <AddNewButton
              onClick={() => {
                setDeliveryAddressesFormIsVisible(true);
              }}
            >
              + Add New Address
            </AddNewButton>
          </div>
        </SelectTitleWrapper>
      )}
      <Fragment>
        {deliveryBusiness && !selectedLocation?.isDeliveryValid && (
          <UnavailableMessage
            onClick={() => {
              updateInterDeliveryDetails(selectedLocation);
              updateInterSelectedDateTime({
                radioValue: {
                  name: 'As soon as possible',
                  value: 'asap',
                },
                dateTime: {
                  date: {
                    name: moment().format('ddd MMM DD'),
                    value: moment().toString(),
                  },
                  time: {
                    name: '',
                    value: '',
                  },
                },
              });
              confirmDeliveryDetails(true);
              updateSelectedLocation(null);
            }}
            title={'We are unable to deliver to this address'}
          />
        )}

        {selectedLocation && (
          <OrderFutureSchedule
            is_future_order_enabled={
              selectedLocation && selectedLocation.deliveryBusiness
                ? selectedLocation.deliveryBusiness.is_future_order_enabled
                : null
            }
            is_asap_order_enabled={
              selectedLocation && selectedLocation.deliveryBusiness
                ? selectedLocation.deliveryBusiness.is_asap_order_enabled
                : null
            }
            selectedLocation={selectedLocation}
            interDeliveryDetails={interDeliveryDetails}
            updateInterDeliveryDetails={updateInterDeliveryDetails}
            interOrderType={interOrderType}
            interSelectedDateTime={interSelectedDateTime}
            updateInterSelectedDateTime={updateInterSelectedDateTime}
            confirmDeliveryDetails={confirmDeliveryDetails}
            availableTimes={availableTimes}
            selectedDateTime={selectedDateTime}
            maxFutureOrderDate={
              selectedLocation && selectedLocation.settings
                ? selectedLocation.settings.max_future_order_date
                : null
            }
            deliveryBusiness={deliveryBusiness}
            isTimeNoLongerValid={isTimeNoLongerValid}
            resetIsTimeNoLongerValid={resetIsTimeNoLongerValid}
            isLocationOrDelivBusinesssAcceptingOrders={
              deliveryBusiness ? deliveryBusiness.accepting_orders : null
            }
            getTimeIntervalsDate={getTimeIntervalsDate}
            specialHours={specialHours}
            orderPacingData={orderPacingData}
            orderMessage={appConfig.orderMessageDelivery}
            isOnline={
              selectedLocation && selectedLocation.settings
                ? selectedLocation.settings.online
                : null
            }
            emptySearchBox={() => emptySearchBox()}
            deepLinkParameters={deepLinkParameters}
            onSeeMenu={() => {
              if (selectedLocation) {
                updateInterDeliveryDetails(selectedLocation);
                updateOrderSettingModalIsVisible(false);
              }
              emptySearchBox();
            }}
            cartReducer={cartReducer}
            emptyCart={emptyCart}
            updateSelectedLocation={updateSelectedLocation}
            showConfirmButton={showConfirmButton}
            setShowConfirmButton={setShowConfirmButton}
            isMessageButtonEnabled={
              getMessageWithButtonStatus(deliveryBusiness)[0]
            }
          />
        )}
        {displayFullfillMessage(deliveryBusiness, cartReducer) && (
          <DeliveryOrderMessage
            deliveryBusiness={deliveryBusiness}
            isOrderSetting
          />
        )}
        {deliveryBusiness && cartErrorMessage && cartErrorMessage.length && (
          <UnavailableProducts
            unavailableProducts={unavailableProducts}
            cartErrorMessage={cartErrorMessage}
          />
        )}
        {showConfirmButton && (
          <ConfirmButton
            text={renderConfirmButtonText(
              selectedLocation,
              interSelectedDateTime,
              'delivery'
            )}
            onClick={() => {
              handleConfirmDeliveryButton(selectedLocation);
            }}
            disabled={isConfirmButtonDisabled(
              interSelectedDateTime,
              selectedLocation,
              'delivery'
            )}
          />
        )}
      </Fragment>
    </Wrapper>
  );
};

export default Delivery;
